import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { BaseSection } from "../../extends/base-section";
import { ResponseUiService } from "../../utils/response-ui.service";
import { FormService } from "../../services/form.service";
import { IFormSection } from '../../interfaces/form-section';
import { MainStore } from "../../store/main-store";
import { UserModel } from "../../shared/models/user-model";
import { SInputComponent } from "../../shared/components/s-input/s-input.component";
import { SAutocompleteComponent, AutocompleteModel } from "../../shared/components/s-autocomplete/s-autocomplete.component";
import { SCheckComponent } from "../../shared/components/s-check/s-check.component";
import { InputModel, InputEnum } from "../../shared/extends-components/binput-component";
import { ConfirmeStore } from "../../store/confirme-store";
import { ButtonModel } from "../../shared/extends-components/bbutton-component";
import { ValoresDonarStore } from "../../store/valores-donar-store";
import { SAlertComponent } from "../../shared/components/s-alert/s-alert.component";
import { MesaggeText } from "../../shared/texts/mesagge-text";
import { IResponseService } from "../../interfaces/response-service";
import { ResponseEnum } from "../../enums/ResponseEnum.enum";
import { environment } from "../../../environments/environment";
import { DescuentoNominaStore } from "../../store/descnomina-store";
import { CheckEnum } from "../../shared/extends-components/bcheck-component";
import { GetIPSevice } from "../../shared/services/getIp.service";
import { CertificadoStore } from "../../store/certificado-donacion-store";
import { DeseaDiaVacacionalStore } from "../../store/deseadiavacacional-store";
import { regexType } from "../../utils/regexDefault";

@Component({
  selector: "app-donaciones",
  templateUrl: "./donaciones.component.html",
  styleUrls: ["./donaciones.component.scss"]
})
export class DonacionesComponent extends BaseSection
  implements OnInit, IFormSection {
  objUsuario: UserModel = MainStore.db.GetUser();
  objColaborador: any;
  nombre1: string;
  nombre2: string;
  apellido1: string;
  apellido2: string;
  isColaborador: boolean = false;
  direccionIp;
  autorizaDescuentoCheck: boolean = false;
  autorizaHabeasCheck: boolean = false;
  autorizaVacacionCheck: boolean = false;
  autorizaDias: string;
  isVacacional: boolean = false;
  isCompensacion: boolean = false;
  autorizoDatos: string = "";
  /**
   * Obtener el components
   */

  @ViewChild("InputNames")
  InputNames: SInputComponent;
  @ViewChild("InputNumberId")
  InputNumberId: SInputComponent;
  @ViewChild("InputValorDonar")
  InputValorDonar: SAutocompleteComponent;
  @ViewChild("InputCertificadoDona")
  InputCertificadoDona: SAutocompleteComponent;
  @ViewChild("InputDescuentoNomina")
  InputDescuentoNomina: SInputComponent;
  @ViewChild("InputAutorizoDescuento")
  InputAutorizoDescuento: SCheckComponent;
  @ViewChild("InputAutorizoHabeas")
  InputAutorizoHabeas: SCheckComponent;
  @ViewChild("InputEmpresaColaborador")
  InputEmpresaColaborador: SInputComponent;
  @ViewChild("InputDiasVacacional")
  InputDiasVacacional: SInputComponent;
  @ViewChild("InputDeseaDiaVacacional")
  InputDeseaDiaVacacional: SAutocompleteComponent;
  @ViewChild("InputOtroValor")
  InputOtroValor: SInputComponent;
  

  TitlePage: "Formulario de Donaciones";

  FieldNames: InputModel = {
    Label: "Nombre completo",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 51,
    Disable: true
  };

  FieldNumberId: InputModel = {
    Label: "Número de identificación",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 20,
    Disable: true
  };


  FieldValorDonar: AutocompleteModel = {
    Label: "Valor a donar",
    IsRequired: false,
    ItemsByStore: ValoresDonarStore.name
  };

  FieldCertificadoDona: AutocompleteModel = {
    IsRequired: true,
    Label: "¿Desea recibir certificado de la donación?",
    ItemsByStore: CertificadoStore.name
  };

  FieldDescuentoNomina: InputModel = {
    Label: "Descontar por nómina a cuotas:",
    IsRequired: false,
    //Rafael
    LenMax: 1,
    Placeholder: "Ej. 1",
    Pattern: regexType.number,
    LenMaxValue: 1
    //Disable: true,
    //ItemsByStore: DescuentoNominaStore.name
  };

  FieldAutorizoDescuento = {
    Type: CheckEnum.Check,
    Items: [{ Label: "AUTORIZO al Empleador para que sea descontado de mi salario los valores antes indicados en los plazos definidos. En caso de retiro como empleado, autorizo se me descuenten de mis prestaciones sociales y de la indemnización si hubiere lugar, los saldos pendientes por descontar a la fecha por los conceptos definidos en este formulario.", Value: ConfirmeStore.YES }]
  };

  FieldAutorizoHabeas = {
    Type: CheckEnum.Check,
    Items: [{ Label: "Autorizo de manera previa, expresa, informada y explícita, al Grupo Coomeva, para el uso y tratamiento de mis datos.", Value: ConfirmeStore.YES }]
  };

  FieldEmpresaColaborador: InputModel = {
    Label: "Empresa",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 51,
    Disable: true
  };

  FieldDiasVacacional: InputModel = {
    Label: "Digite el número de días de pasivo vacacional que desea donar",
    IsRequired: false,
    Type: InputEnum.Text,
    LenMax: 3,
    Disable: false
  };

  FieldDeseaDiaVacacioanl: AutocompleteModel = {
    Label: "¿Desea donar días de pasivo vacacional?",
    IsRequired: true,
    ItemsByStore: DeseaDiaVacacionalStore.name
  };

  FieldOtroValor: InputModel = {
    Label: "Aporte libre",
    IsRequired: false,
    LenMax: 18,
    Placeholder: "Ej. $10.000",
    Pattern: regexType.currency,
    IsCurrency: true,
    Disable: true,
    Tooltip: {
      Label: MesaggeText.TOOLTIP_APORTE_LIBRE
    }
  };

  btnSave: ButtonModel = {
    Label: "Guardar",
    Hidden: true,
    IconCss: "save"
  };

  constructor(
    public responseUI: ResponseUiService,
    public formServ: FormService,
    private ipService: GetIPSevice
  ) {
    super();
  }

  ngOnInit() {

    this.getIP();
    SAlertComponent.ShowSpinner();
    this.InputNumberId.SetDisable(true);
    this.InputNames.SetDisable(true);
    this.InputEmpresaColaborador.SetDisable(true);

    this.InputOtroValor.SetDisable(true);
    this.InputOtroValor.SetRequired(false);
    //Rafael
    this.InputDescuentoNomina.SetDisable(true);

    //this.InputDiasVacacional.SetDisable(false);
    this.autorizaDias = '';
    //this.InputNONE.SetDisable(true);

    this.formServ.GetDatosColaborador(this.objUsuario.numDoc.toString())
      .then(response => {
        let variableResponse: any = response;
        if (variableResponse.empleado != null) {
          this.isColaborador = true;
          this.objColaborador = variableResponse.empleado[0];
          this.nombre1 = this.objColaborador.primerNombre != undefined ? this.objColaborador.primerNombre.trim() : '';
          this.nombre2 = this.objColaborador.segundoNombre != undefined ? this.objColaborador.segundoNombre.trim() : '';
          this.apellido1 = this.objColaborador.primerApellido != undefined ? this.objColaborador.primerApellido.trim() : '';
          this.apellido2 = this.objColaborador.segundoApellido != undefined ? this.objColaborador.segundoApellido.trim() : '';
        } else {
          return SAlertComponent.AlertNoColaborador("La campaña es inicialmente exclusiva para colaboradores del Grupo Coomeva.", ""
          ).then(isaceppt => {
            SAlertComponent.CloseSpinner();
            window.location.href = MainStore.ORIGIN == 1 ?
              window.location.origin + environment.covid19 :
              environment.redirect;
          });
        }
      });
  }//aporte libre desde $30.000

  ngAfterContentInit() {
    setTimeout(() => {
      if (this.isColaborador) {
        this.FieldNumberId.Data = this.objUsuario.numDoc.toString();
        this.FieldNames.Data = this.nombre1 + ' ' + this.nombre2 + ' ' + this.apellido1 + ' ' + this.apellido2;
        this.FieldEmpresaColaborador.Data = this.objColaborador.empresa;
        SAlertComponent.CloseSpinner();
      }
    }, 2000);
  }

  /**
    * @author Jose Wilson Mulato
    * @description obtiene Direccion Ip
    */
  getIP() {
    this.formServ.getIPAddress().subscribe((res: any) => {
      this.direccionIp = res.ip;
    });
  }

  onChangeSelectItem(item) {

    if (item == '1') {
      this.InputDiasVacacional.SetDisable(true);
      this.autorizaDias = 'noVisible';
      this.isVacacional = false;
      this.autorizoDatos = '';
    } else {
      this.InputDiasVacacional.SetDisable(false);
      this.autorizaDias = '';
      this.isVacacional = true;
      if(this.isCompensacion) {
        this.autorizoDatos = 'autorizoDatos';
      }
    }
  }

  onChangeValorDonar(item) {
    this.InputOtroValor.SetDisable(true);
    this.InputOtroValor.SetRequired(false);
    this.InputOtroValor.SetData("");
    //this.InputDescuentoNomina.SetRequired(true);
    this.InputDescuentoNomina.SetDisable(false);
    this.InputDescuentoNomina.set("Máximo 2 cuotas");
    this.InputDescuentoNomina.SetData("");
    
    if (item == '') {      
      this.isCompensacion = false;
      this.autorizoDatos = '';
      
    } else {
      console.debug(item)
      if(item == 0) {
        this.InputOtroValor.SetDisable(false);
        this.InputOtroValor.SetRequired(true);
      }
      //Rafael
      if(item == 4 || item == 5 || item == 6) {
        this.InputDescuentoNomina.set("No aplica");
        this.InputDescuentoNomina.SetDisable(true); 
        this.InputDescuentoNomina.SetData("1");
     }

      
      this.isCompensacion = true;
      if(this.isVacacional) {
        this.autorizoDatos = 'autorizoDatos';
      }
      
    }
  }

  /**
     * @author Jose Wilson Mulato
     * @description Mandar a confirmar la donacion
     */
  clickConfirm() {

    /*if (!this.FieldDeseaDiaVacacioanl.Data) {
      return SAlertComponent.AlertWarning("El campo desea donar días de pasivo vacacional es obligatorio");
    }

    if (this.FieldDeseaDiaVacacioanl.Data["Value"] == 'NO') {
      if (!this.FieldValorDonar.Data) {
        return SAlertComponent.AlertWarning("El valor a donar es obligatorio");
      }

      if (!this.FieldDescuentoNomina.Data) {
        return SAlertComponent.AlertWarning("El valor descuento por nómina es obligatorio");
      }

      if (!this.autorizaDescuentoCheck) {
        return SAlertComponent.AlertWarning("Favor autorizar el descuento por nómina");
      }
    } else {
      if (!this.FieldDiasVacacional.Data) {
        return SAlertComponent.AlertWarning("El n\u00FAmero de d\u00EDas de pasivo vacacional es obligatorio");
      } else {
        if (!this.isNumber(this.FieldDiasVacacional.Data)) {
          return SAlertComponent.AlertWarning("El n\u00FAmero de d\u00EDas de pasivo vacacional es num\u00E9rico");
        } else if(parseInt(this.FieldDiasVacacional.Data) <= 0 || parseInt(this.FieldDiasVacacional.Data) > 8) {
          return SAlertComponent.AlertWarning("El n\u00FAmero de d\u00EDas de pasivo vacacional debe ser mayor a cero y m\u00E1ximo de (8) ocho d\u00EDas por mes.");
        }
      }

      if (!this.autorizaVacacionCheck) {
        return SAlertComponent.AlertWarning("Favor autorizar el descuento de d\u00EDas pasivos vacacionales");
      }

      if (this.FieldValorDonar.Data) {
        if (!this.autorizaDescuentoCheck) {
          return SAlertComponent.AlertWarning("Favor autorizar el descuento por nómina");
        }
      }

    }*/

    /*if (!this.FieldCertificadoDona.Data) {
      return SAlertComponent.AlertWarning("El campo certificado de donación es obligatorio");
    }*/

    if (this.FieldValorDonar.Data["Value"] == -1 && this.InputOtroValor.GetData() < 10000) {
      return SAlertComponent.AlertWarning("El valor minimo en donación de dinero es de $10.000");
    }
    //Rafael
    if (this.FieldValorDonar.Data["Value"] == -1 && this.InputOtroValor.GetData() > 3000000) {
      return SAlertComponent.AlertWarning("El valor maximo en donación de dinero es de $3.000.000");
    }
    if (this.InputDescuentoNomina.GetData() > 2 || this.InputDescuentoNomina.GetData() == 0 || !this.isNumber(this.InputDescuentoNomina.GetData())) {
      return SAlertComponent.AlertWarning("Las cuotas a descontar deben ser mínimo 1 y máximo 2");
    }
    if (!this.autorizaHabeasCheck) {
      return SAlertComponent.AlertWarning("Favor autorizar el tratamiento a sus datos");
    }

    if (!this.autorizaDescuentoCheck) {
      return SAlertComponent.AlertWarning("Favor autorizar el descuento");
    }

    /*if (this.FieldDeseaDiaVacacioanl.Data["Value"] == 'SI') {
      if(this.FieldValorDonar.Data) {
        SAlertComponent.Confirm2(
          "¿Aceptas realizar tu donación por valor de " + this.FieldValorDonar.Data["Value"] + 
          " y " + this.FieldDiasVacacional.Data + 
          " día(s) de Pasivo Vacacional?",
          true,
          ""
        ).then(isaceppt => {
          if (isaceppt) {
            this.Save();
          } else {
            return;
          }
        });
      } else {
        SAlertComponent.Confirm2(
          "¿Aceptas realizar tu donación por " + this.FieldDiasVacacional.Data + 
          " día(s) de Pasivo Vacacional?",
          true,
          ""
        ).then(isaceppt => {
          if (isaceppt) {
            this.Save();
          } else {
            return;
          }
        });
      }
      
    } else {*/
      let valorDonar = this.FieldValorDonar.Data["Value"];

      if(valorDonar == '-1') {
        valorDonar = '$'+new Intl.NumberFormat().format(parseInt(this.InputOtroValor.GetData()));
      }


      SAlertComponent.Confirm2(
        "¿Aceptas realizar tu donación por valor de " + valorDonar
        + "?",
        true,
        ""
      ).then(isaceppt => {
        if (isaceppt) {
          this.Save();
        } else {
          return;
        }
      });
    //}
    
  }
  /**
   * @author Jose Wilson Mulato
   * @description Mandar a guardar el dato al servicio
   */
  async Save(): Promise<any> {

    let valorDonar = '0';
    let descontarNomina = 'N';

    if(this.FieldValorDonar.Data) {
      valorDonar = this.FieldValorDonar.Data["Value"];
    }

    if(this.FieldDescuentoNomina.Data) {
      //descontarNomina = this.FieldDescuentoNomina.Data["Value"];
      descontarNomina = this.InputDescuentoNomina.GetData();
    }

    if(valorDonar == '-1') {
      valorDonar = this.InputOtroValor.GetData();
    }
    if(valorDonar == '1 día de vacaciones' || valorDonar == '2 días de vacaciones' || valorDonar == '3 días de vacaciones') {
      descontarNomina = 'N';
    }

    return new Promise((success, fail) => {
      SAlertComponent.ShowSpinner();
      MainStore.db
        .SetDonacion({
          identificacionColaborador: this.InputNumberId.GetData(),
          certificadoDonacion: 'N',//this.FieldCertificadoDona.Data["Value"],
          ip: this.direccionIp == null && this.direccionIp == undefined ? 'NOIP' : this.direccionIp,
          valorDonacion: valorDonar,
          estadoReportOperacion: 'N',
          nombreDonante: this.nombre1 + ' ' + this.nombre2 + ' ' + this.apellido1 + ' ' + this.apellido2,
          email: this.objColaborador.email,
          descEmpresaColaborador: this.objColaborador.empresa,
          descontarNomina: descontarNomina,
          autorizoDescuento: this.autorizaDescuentoCheck == true ? 'S' : 'N',
          codEmpresaColaborador: this.objColaborador.codEmpresa,
          cantidadDiaVacacional: "",//this.FieldDiasVacacional.Data,
          autorizaDiaVacacional: this.autorizaVacacionCheck == true ? 'S' : 'N',
        })
        .then((response: IResponseService) => {
          this.responseUI.CheckResponseForError(response).then(result => {
            if (response.messageError == null && response.status == ResponseEnum.OK) {
              this.showMessageDias(response.data);
            }

            if (response.messageError == MesaggeText.DONACION_EXIST && response.status == ResponseEnum.OK) {
              SAlertComponent.AlertInfo(response.messageError);
            }
            success(response.status == ResponseEnum.OK);
          });
        })
        .catch(error => {
          SAlertComponent.CloseSpinner();
          this.responseUI.CheckResponseForError(error);
          success(false);
        });
    });
  }

  isNumber(value: string | number): boolean {
    return ((value != null) && !isNaN(Number(value.toString())));
  }

  showMessageDias(data: any) {
    let message = "<center> <b>¡DONACIÓN EXITOSA!</b></center> <br> <div style='text-align: justify;'>Tu donación por ";
    let isValorDonacion = false;
    let isVacacional = false;
    console.debug(data.valorDonacion);

    console.debug(parseInt(data.valorDonacion));
    if(data.valorDonacion != '' && parseInt(data.valorDonacion) > 0) {
      isValorDonacion = true;

      if(parseInt(data.valorDonacion) >= 10000) {
        message += "valor de $" + new Intl.NumberFormat().format(parseInt(data.valorDonacion)) + "";
      } else {
        message += "valor de " + data.valorDonacion + "";
      }
      
    }

    if(data.cantidadDiaVacacional != '' && data.cantidadDiaVacacional != null) {
      isVacacional = true;
      if(isValorDonacion) {
        message += ' y ';
      }
      message += "" + data.cantidadDiaVacacional + " día(s) de Pasivo Vacacional";
    }

    message += "  ha sido exitosa. Será descontada en " + data.descontarNomina + " cuota(s) por nómina.</div>" ;//+ 

    /*if(isVacacional && isValorDonacion) {
      message += "  ha sido exitosa. Sera descontada en una sola cuota por nómina.</div>" ;//+ 
    } else if(isVacacional && !isValorDonacion) {
      message += "  ha sido exitosa. </div>" + 
      "<center>Serán liquidados por nómina";
    }

    if(isVacacional && !isValorDonacion) {
      message += " en una (1) sola cuota.</center>";
    } else if(isVacacional && isValorDonacion) {
      message += " Los días de tu pasivo vacacional serán descontados en 1 (una) cuota.";
    } else {
      message += ".</center>";
    }*/
    message +=
    "<center><b>¡Nuestras acciones, son nuestro mensaje cooperativo¡</b></center>";

    let espacio = document.createTextNode("      ");
    SAlertComponent.CloseSpinner();
    SAlertComponent.AlertMessage(message).then(isaceppt => {
      
      window.location.href = MainStore.ORIGIN == 1 ?
        window.location.origin + environment.covid19 :
        environment.redirect;
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description Valida los campos este correctos
   */
  async Valid(): Promise<any> {
    let isValid = this.ValidFields([
      this.InputNumberId,
      this.InputNames,
      this.InputValorDonar,
      this.InputCertificadoDona
    ]);
    return isValid;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/donaciones/donaciones.component.ts